import { Injectable } from '@angular/core';
import { UtilService, LocalStorageService, NameValue } from '../../shared/index';
import { ProfileSearchComponentModel } from '../search/profile-search-component.model';
import { ProfileSearchLoadOptionsDto } from './dto/profile-search-load-options.dto';

@Injectable()
export class ProfileSearchV2ParameterService {
  private _paramNameSearchResults = 'profileSearchV2Results';
  private _paramNameSearchLoadOptions = 'profileSearchLoadOptions'; // the search load options didn't change, so we keep this the same ....for now

  constructor(private _localStorageService: LocalStorageService) {
    const version = window['wlVersion'];
    this._paramNameSearchResults += version;
    this._paramNameSearchLoadOptions += version;
  }

  hasResults(): boolean {
    return this._localStorageService.hasItem(this._paramNameSearchResults);
  }

  hasProfileSearchResults() {
    return this._localStorageService.hasItem(this._paramNameSearchResults);
  }

  getProfileSearchResults(): any {
    //gotta be any because the results are dynamic
    if (this._localStorageService.hasItem(this._paramNameSearchResults)) {
      return this._localStorageService.getObject(this._paramNameSearchResults);
    }
  }

  setProfileSearchResults(params: any) {
    this._localStorageService.setObject(this._paramNameSearchResults, params);
  }

  clearProfileSearchResults() {
    if (this._localStorageService.hasItem(this._paramNameSearchResults)) {
      this._localStorageService.removeItem(this._paramNameSearchResults);
    }
  }

  getSearchLoadOptions(): ProfileSearchLoadOptionsDto {
    if (this._localStorageService.hasItem(this._paramNameSearchLoadOptions)) {
      return this._localStorageService.getObject(this._paramNameSearchLoadOptions);
    }
    return null;
  }

  setSearchLoadOptions(options: ProfileSearchLoadOptionsDto) {
    this._localStorageService.setObject(this._paramNameSearchLoadOptions, options);
  }

  clearSearchLoadOptions() {
    if (this._localStorageService.hasItem(this._paramNameSearchLoadOptions)) {
      this._localStorageService.removeItem(this._paramNameSearchLoadOptions);
    }
  }
}
